const urlRegex = /^https?:\/\//;

export const isValidUrl = (url: string) => urlRegex.test(url);

export const sanitiseUrl = (url: string) => {
  // Trim whitespace
  const sanitisedUrl = url.trim();

  // Validate scheme
  if (!isValidUrl(url)) {
    throw new Error("URL must start with 'http://' or 'https://'");
  }

  try {
    let urlObject = new URL(sanitisedUrl);

    urlObject.hostname = urlObject.hostname.toLowerCase();

    // Remove trailing slash
    if (urlObject.pathname !== '/') {
      urlObject.pathname = urlObject.pathname.replace(/\/+$/, '') || '';
    }

    // Reconstruct the URL from its components
    // Note: The URL interface automatically handles encoding of the pathname
    return urlObject.toString().replace(/\/+$/, '');
  } catch (e) {
    throw new Error('Invalid URL provided');
  }
};
